<template>
	<VueSlider @change="onChange" class="width-100" v-bind="localOptions" :contained="true" v-model="localValue">
		<template v-slot:dot="{ focus }">
			<div class="slider-dot" :class="{ focus }" />
		</template>
		<template v-slot:step="{ label, active }">
			<div v-if="!isEdgeLabel(Number(label))" :class="['custom-step', { active }]" />
		</template>
		<template v-slot:label="{ label, active }">
			<div :class="['vue-slider-mark-label custom-label', { active }]">
				{{ getReadableLabel(label) }}
				<slot name="label-appendix" v-bind="{ label }" />
			</div>
		</template>
		<template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope"><slot :name="slot" v-bind="{ ...scope, item }" /></template>
	</VueSlider>
</template>

<script>
import 'vue-slider-component/theme/default.css';
import VueSlider from 'vue-slider-component/dist-css/vue-slider-component.umd.min.js';

import { addBigNumberSuffix } from '@/utils/helpers';

import 'vue-slider-component/dist-css/vue-slider-component.css';
export default {
	name: 'Slider',
	components: { VueSlider },
	props: {
		value: { type: Number },
		applyOnEdges: { type: Boolean, default: true },
		options: { type: Object, default: () => ({}) },
	},
	methods: {
		onChange(newV) {
			this.$emit('onChange', newV);
		},
		isEdgeLabel(label) {
			if (this.applyOnEdges) {
				return false;
			}
			return label === this.localOptions.min || label === this.localOptions.max;
		},
		getReadableLabel(label) {
			if (isNaN(label)) {
				return addBigNumberSuffix(label.replace('+', '')) + '+';
			}
			return addBigNumberSuffix(label);
		},
	},
	data() {
		return {
			localValue: String(this.value),
			localOptions: {
				...{
					min: 0,
					max: 100,
					height: 9,
					dotSize: 20,
					duration: 0.5,
					tooltip: 'none',
				},
				...this.options,
			},
		};
	},
};
</script>

<style scoped lang="scss">
.slider-dot {
	width: 100%;
	height: 100%;
	cursor: pointer;
	border-radius: 50%;
	transition: all 0.3s;
	background: #4a3aff;
	box-shadow: none;
	&:hover {
		box-shadow: 0px 3px 6px #00000029;
	}
	&.focus {
		box-shadow: 0px 3px 6px #00000029;
	}
}

.custom-step {
	width: 2px;
	height: 10px;
	margin-top: 10px;
	margin-left: 4px;
	background: #e2e7f1;
	transition: all 0.3s;
	&.active {
		transition: all 0.3s;
		opacity: 1;
	}
}

.custom-label {
	transition: all 0.3s;
	opacity: 0.5;
	font-size: 10px;
	color: #262626;
	margin-top: 14px;
	font-weight: normal;
	&.active {
		opacity: 1;
		transition: all 0.3s;
	}
}

::v-deep {
	.vue-slider-rail {
		border-radius: 100px;
		background: #ffffff;
		border: 1px solid #e2e7f1;
	}
	.vue-slider-process {
		opacity: 0.5;
		background: #4a3aff;
	}
}
</style>
